module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "price-demo",
    attrs: {
      "title": "Price"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "fontSize",
      "description": "字号大小",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Price', [_vm._v("24")]), _vm._v(" "), _c('Price', {
    attrs: {
      "font_size": 36
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('Price', {
    attrs: {
      "font_size": 48
    }
  }, [_vm._v("48")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('Price', [_vm._v("99")]), _vm._v(" "), _c('Price', {
    attrs: {
      "color": '#00a0e9'
    }
  }, [_vm._v("998")]), _vm._v(" "), _c('Price', {
    attrs: {
      "color": 'rgba(99, 99, 99, 1)'
    }
  }, [_vm._v("9998")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "super",
      "description": "价格符号对其文本上标",
      "code": _vm.super_code
    },
    slot: "left"
  }, [_c('Price', {
    attrs: {
      "super": true
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('Price', {
    attrs: {
      "super": true,
      "font_size": 36
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('Price', {
    attrs: {
      "super": true,
      "font_size": 48
    }
  }, [_vm._v("48")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "delete",
      "description": "删除样式",
      "code": _vm.delete_code
    },
    slot: "right"
  }, [_c('Price', {
    attrs: {
      "delete": true
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('Price', {
    attrs: {
      "delete": true,
      "font_size": 36
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('Price', {
    attrs: {
      "delete": true,
      "font_size": 48
    }
  }, [_vm._v("48")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "suffix",
      "description": "后缀文本",
      "code": _vm.suffix_code
    },
    slot: "right"
  }, [_c('Price', {
    attrs: {
      "suffix": "起"
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('Price', {
    attrs: {
      "suffix": "起",
      "font_size": 36
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('Price', {
    attrs: {
      "suffix": "起",
      "font_size": 48
    }
  }, [_vm._v("48")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa55db6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Price.vue
// module id = 662
// module chunks = 0